import React from 'react';
import { reportClientError } from '../../helpers/errorReporting';

export default class ErrorBoundary extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  componentDidCatch(error, errorInfo) {
    // Catch errors in any components below and re-render with error message
    this.setState({
      error: error,
      errorInfo: errorInfo
    })
    reportClientError(error && error.toString(), errorInfo && errorInfo.componentStack);
  }
  
  render() {
    if (this.state.errorInfo) {
      // Error path
      return (
        <div>
          <h3><b>Something went wrong.</b></h3>
          <details style={{ whiteSpace: 'pre-wrap' }}>
            {this.state.error && this.state.error.toString()}
            <br />
            {this.state.errorInfo.componentStack}
          </details>
        </div>
      );
    }
    // Normally, just render children
    return this.props.children;
  }  
}